import moment from 'moment';
import Api from '../Api';
import { parseUnits, formatHash } from '../utils';
import { closeModal } from '../modal';
import coins from '../common';

export function createModalApp(selector, store) {
    return PetiteVue.createApp({
        store,
        parseUnits,
        ticketCode: '',
        isValidating: false,
        isInvalidTicket: false,
        ticket: null,
        ticketUses: 1,
        walletAddr: "",
        oneUseReward: 0.23,
        partyId: null,
        party: null,
        tillLaunch: "00:00:00",
        updateInterval: null,
        coin: null,
        isJoining: false,
        error: null,

        onPartyId(partyId) {
            if (!partyId) return;

            console.log('onPartyId', partyId);
            this.partyId = partyId;
            this.loadParty();
        },

        async loadParty() {
            try {
                this.party = await Api.party.get(this.partyId);
                this.coin = coins.find(coin => coin.code === this.party.coin);
            } catch (error) {
                console.error('Failed to load party', error);
            }

            this.updateTillLaunch();
            if (this.updateInterval) {
                clearInterval(this.updateInterval);
            }

            this.updateInterval = setInterval(() => {
                this.updateTillLaunch();
            }, 1000);
        },

        async validateTicketCode() {
            console.log('validateTicketCode', this.ticketCode);
            if (!this.ticketCode.trim()) {
                return false;
            }

            this.isValidating = true;
            try {
                this.ticket = await Api.ticket.get(this.ticketCode.trim());
                this.isInvalidTicket = this.ticket == null || this.ticket.status != 'active';
            } catch (e) {
                this.isInvalidTicket = true;
            }

            this.isValidating = false;
        },

        close() {
            closeModal(selector);
        },

        sendConversion() {
            if (window.gtag) {
                window.gtag('event', 'ads_conversion_party_joined', {});
            }
        },

        get partyShares() {
            if (!this.party || !this.party.miners) return 0;
            return this.party.miners.reduce((acc, miner) => acc + miner.shares, 0);
        },

        get shareReward() {
            if (!this.party || !this.party.chainStats) return 0;

            let potentialUses = Math.min(10000, parseInt(this.ticketUses) || 0);
            let reward = this.party.chainStats.blockRewardUSD / (this.partyShares + potentialUses);
            return Math.round(reward * 100) / 100;
        },

        get shareRewardInCoin() {
            if (!this.party || !this.party.chainStats) return 0;

            let potentialUses = Math.min(10000, parseInt(this.ticketUses) || 0);
            let reward = this.party.chainStats.blockReward / (this.partyShares + potentialUses);
            return Math.round(reward * 100000) / 100000;
        },

        get lowestReward() {
            if (!this.party || !this.party.chainStats) return 0;
            let reward = this.party.chainStats.blockRewardUSD / this.party.maxShares;
            return Math.round(reward * 100) / 100;
        },

        get isValidWallet() {
            return this.walletAddr && this.walletAddr.length > 20;
        },

        get totalWork() {
            if (!this.party || !this.party.chainStats) return 0;
            let workPerUse = this.party.oneTicketTH / 0.004294967296;
            let totalWork = workPerUse * this.partyShares;
            return totalWork;
        },

        get potentialWork() {
            if (!this.party || !this.party.chainStats) return 0;
            if (!this.ticket || this.isInvalidTicket) return 0;

            let potentialUses = Math.min(10000, parseInt(this.ticketUses) || 0);
            let workPerUse = this.party.oneTicketTH / 0.004294967296;
            let totalWork = workPerUse * potentialUses;
            return totalWork;
        },

        get chanceToFindBlock() {
            let total = this.totalWork + this.potentialWork;
            if (!total) return 0;

            if (total > this.party.chainStats.difficulty) {
                let approx = Math.round(total / this.party.chainStats.difficulty);
                return "~" + approx + (approx > 1 ? " blocks" : " block");
            }

            let chance = this.party.chainStats.difficulty / total;
            return "1 : " + Math.round(chance);
        },

        get maxShares() {
            if (!this.party) return 0;
            let currentShares = this.partyShares;
            return this.party.maxShares - currentShares;
        },

        async joinParty() {
            this.error = null;
            if (!this.isValidWallet) {
                this.error = "Please enter a valid wallet address";
                return;
            }

            this.sendConversion();

            this.isJoining = true;
            try {
                await Api.party.join(this.partyId, this.walletAddr, this.ticketCode, Math.min(this.ticketUses, this.maxShares));
                this.close();
                
                // redirect user to /party/partyId
                window.location.href = `/party/${this.partyId}`;
            } catch (e) {
                
                if (e.response && e.response.data) {
                    this.error = e.response.data.error;
                } else {
                    this.error = 'Failed to join party: ' + e.message;
                }
            }
            this.isJoining = false;
        },

        updateTillLaunch() {
            let launch = moment(this.party.launchDate);
            let now = moment();
            let diff = launch.diff(now);
            if (diff < 0) {
                this.tillLaunch = '00:00:00';
                return;
            }
            let duration = moment.duration(diff);
            let hours = Math.floor(duration.asHours());
            let minutes = duration.minutes();
            let seconds = duration.seconds();
            this.tillLaunch = `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        }
        
    });
}